define('modules/form_editor/views/preview_form',['require','exports','module','base/collectionview','./preview_element_factory','ldsh!../templates/preview_form'],function(require, exports, module){
  "use strict";
  var CollectionView = require("base/collectionview"),
      PreviewItemFactory = require("./preview_element_factory");

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/preview_form"),
    itemView: PreviewItemFactory,
    itemContainer: "form",
    // className: "panel panel-primary",
    // attributes: { style: "max-height: 400px; overflow: auto"},
    initialize: function(options){
      this.vent = options.vent;
      this.activeItem = options.activeItem;
      this.listenTo(this.childVent, "item:select", this.onChildItemSelect);
      this.listenTo(this.activeItem, "change", this.onActiveItemChange);
    },
    onChildItemSelect: function(view, model){
      // _.each(this._childViews, function(view){
      //   view.$el.removeClass("item-is-selected");
      // }, this);
      // view.$el.addClass("item-is-selected");
      this.vent.trigger("select:element", view.model);
    },
    //,
    // onActiveItemChange: function(model){
    //   var item = model.get("item");
    //   _.each(this._childViews, function(view){
    //     view.$el.toggleClass("item-is-selected", view.model === item);
    //   }, this);
    // }
  });
});

